exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".std-klass-traits{display:flex;justify-content:space-between;text-align:left}.std-klass-traits .std-klass-trait{flex:1 1 31%}.std-klass-traits .std-klass-trait>:hover{background:var(--secondary-color-light)}.std-klass-traits .std-klass-trait--class-skills{flex:1 1 64%;display:flex}.std-klass-traits .std-klass-trait--class-skills>strong{min-width:80px}.std-klass-traits .no-hover:hover{background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01b9dd20","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SelectClass.vue
// module id = 57
// module chunks = 0